module.exports = __webpack_public_path__ + "static/media/photostickomni-32.33c1df9f.png";